import { configureStore } from "@reduxjs/toolkit";
import couponReducer from "./slices/couponSlice";
import userReducer from "./slices/userSlice";
import vendorReducer from "./slices/vendorSlice";
import businessReducer from "./slices/businessSlice";
import reviewReducer from "./slices/reviewSlice";
import bookmarkReducer from "./slices/bookmarkSlice";
import adminReducer from "./slices/adminSlice";

export const store = configureStore({
    reducer: {
        coupons: couponReducer,
        user: userReducer,
        vendors: vendorReducer,
        businesses: businessReducer,
        reviews: reviewReducer,
        bookmarks: bookmarkReducer,
        admin: adminReducer,
    },
});